// components/ClientFormPage.jsx
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import {
  fetchClient,
  createClient,
  updateClient
} from "../../api/clientsApi";
import {
  selectCurrentClient,
  clearCurrentClient
} from "../../store/slices/clients.slice";
import { ClientForm } from "./ClientForm"; // your presentational form component

const ClientFormPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { clientId } = useParams(); // e.g. "/clients/:clientId/edit"

  // We’re in 'edit mode' if we have a clientId
  const isEditMode = Boolean(clientId);

  // Current client in Redux, if fetched
  const currentClient = useSelector(selectCurrentClient);

  useEffect(() => {
    if (isEditMode) {
      // Fetch the client data from the API
      dispatch(fetchClient(clientId));
    }
    // On unmount, clear current client from Redux
    return () => {
      dispatch(clearCurrentClient());
    };
  }, [dispatch, clientId, isEditMode]);

  // Handler for the form submission
  const handleSubmit = async (values) => {
    try {
      if (isEditMode) {
        // If editing, call update
        await dispatch(updateClient({ clientId, updateData: values }));
      } else {
        // If creating, call create
        await dispatch(createClient(values));
      }
      // Navigate back to /clients after a successful create or update
      navigate("/clients");
    } catch (error) {
      // handle or display error if needed
      console.error("Error creating/updating client:", error);
    }
  };

  return (
    <ClientForm
      mode={isEditMode ? "edit" : "create"}
      initialValues={currentClient || {}}
      onSubmit={handleSubmit}
    />
  );
};

export default ClientFormPage;
